// Cookie-consent store — plain module, no React dependency.
// Source of truth is localStorage. Components subscribe to changes via
// `subscribeConsent`. The "Cookie settings" footer link opens the banner
// again via `openSettings` / `subscribeSettingsOpen`.
//
// Consent shape:
//   { analytics: boolean, chat: boolean, ts: number }
//
// A missing / invalid record means the user has NOT made a choice yet — the
// banner should be shown and gated integrations (GA4, Crisp) must not load.

const STORAGE_KEY = "lutrom.cookie.consent.v1";

const consentListeners = new Set();
const openListeners = new Set();

const isBrowser = () => typeof window !== "undefined";

export const getConsent = () => {
  if (!isBrowser()) return null;
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (
      typeof parsed === "object" &&
      parsed !== null &&
      typeof parsed.analytics === "boolean" &&
      typeof parsed.chat === "boolean"
    ) {
      return parsed;
    }
    return null;
  } catch {
    return null;
  }
};

export const setConsent = ({ analytics, chat }) => {
  if (!isBrowser()) return;
  const record = {
    analytics: Boolean(analytics),
    chat: Boolean(chat),
    ts: Date.now(),
  };
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(record));
  } catch {
    // localStorage disabled — silently no-op
  }
  consentListeners.forEach((cb) => {
    try { cb(record); } catch { /* ignore */ }
  });
};

export const subscribeConsent = (cb) => {
  consentListeners.add(cb);
  return () => consentListeners.delete(cb);
};

export const openSettings = () => {
  openListeners.forEach((cb) => {
    try { cb(); } catch { /* ignore */ }
  });
};

export const subscribeSettingsOpen = (cb) => {
  openListeners.add(cb);
  return () => openListeners.delete(cb);
};
